function fromLittleEndianDecBytes (a) {
  let sum = 0
  for (let i = 0; i < a.length; i++)
    sum |= a[i] << (i * 8)
  return sum
}

function readDecimal (buffer, start, length) {
  const a = new Uint8Array(buffer, start, length)
  return fromLittleEndianDecBytes(a)
}

export default function getWavLength (blob) {
  return new Promise(function (resolve, reject) {
    let reader = new FileReader()
    reader.onload = function () {
      const result = this.result
      const byteRate = readDecimal(result, 28, 4)
      const dataLength = readDecimal(result, 40, 4)
      resolve(dataLength > -1 ? (dataLength / byteRate) * 1000 : -1)
    }
    reader.onerror = function (e) { reject(new Error('Error reading' + blob.name + ': ' + e.target.result)) }
    reader.readAsArrayBuffer(blob.slice(0, 44))
  })
}
